import React from 'react';
import moment from 'moment';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function CommonUI(_ref) {
  var _config$commonCompone, _config$events, _config$events2;
  var title = _ref.title,
    eventHost = _ref.eventHost,
    eventDate = _ref.eventDate,
    config = _ref.config;
  var date = new Date(eventDate);
  // console.log('EVENT DATE', date.toLocaleDateString('en-US'));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: 'px-4 pt-4 pb-6 ' + "".concat(config === null || config === void 0 || (_config$commonCompone = config.commonComponents) === null || _config$commonCompone === void 0 ? void 0 : _config$commonCompone.backgroundColor),
      children: [/*#__PURE__*/_jsx("h1", {
        className: "text-primary leading-5 uppercase text-[18px] font-medium mt-2  ".concat(config === null || config === void 0 || (_config$events = config.events) === null || _config$events === void 0 ? void 0 : _config$events.fontHeading, " ").concat((config === null || config === void 0 || (_config$events2 = config.events) === null || _config$events2 === void 0 || (_config$events2 = _config$events2.eventLayout) === null || _config$events2 === void 0 ? void 0 : _config$events2.titleClass) || '', " "),
        children: title
      }), /*#__PURE__*/_jsx("h3", {
        className: "mt-4 uppercase ".concat(config !== null && config !== void 0 && config.darkMode ? 'text-[#9b9b9b]' : 'text-black', " ").concat(config.events.fontBody),
        children: eventHost
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "absolute flex flex-col justify-center h-14 w-14 bg-black opacity-70 -top-2 right-2 text-center text-white",
      children: [/*#__PURE__*/_jsx("p", {
        children: moment(eventDate).format('D')
      }), /*#__PURE__*/_jsx("p", {
        className: "-mt-1",
        children: moment(eventDate).format('MMM') + "'" + moment(eventDate).format('YY')
      })]
    })]
  });
}
export default CommonUI;